import React from "react";
import { Timer, Trophy, Target, ChevronRight } from "lucide-react";

const SERIES = [
  {
    badge: "Grand Test",
    title: "All-India NEET PG Grand Tests",
    desc: "Full-length 200-question simulations under timed exam conditions with all-India rank.",
    points: ["Negative marking", "Real-time leaderboard", "Subject-wise analytics"],
    color: "from-blue-600 to-indigo-600",
  },
  {
    badge: "Subject Wise",
    title: "Subject-wise Mini Tests",
    desc: "Focused tests covering one subject at a time — track strength and weak topics.",
    points: ["50 MCQs each", "Solution videos", "Detailed analytics"],
    color: "from-indigo-600 to-indigo-600",
  },
  {
    badge: "Daily Quiz",
    title: "Daily 10-MCQ Quiz",
    desc: "Stay consistent. A daily quiz with explanations to keep momentum every single day.",
    points: ["Streak rewards", "AI explanations", "Quick revision"],
    color: "from-indigo-600 to-cyan-600",
  },
];

export default function TestSeries() {
  return (
    <section id="test-series" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.2em] text-blue-700 bg-blue-50 px-3 py-1.5 rounded-full">
            <span className="h-1.5 w-1.5 rounded-full bg-blue-600" /> Test Series
          </div>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900 mt-4">
            Practise like it's the real exam
          </h2>
            <p className="text-sm text-slate-600 mt-3">Choose from grand tests, subject-wise tests and daily quizzes — all backed by performance analytics.</p>
        </div>

        <div className="grid lg:grid-cols-3 gap-5">
          {SERIES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`test-series-card-${i}`}
              className="relative overflow-hidden rounded-3xl p-6 bg-white border border-slate-200 lift"
            >
              <div className={`absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r ${s.color}`} />
              <span className="inline-block text-[10px] font-bold uppercase tracking-[0.18em] text-blue-700 bg-blue-50 px-2.5 py-1 rounded-full">
                {s.badge}
              </span>
              <h3 className="mt-4 font-heading text-xl font-bold text-slate-900">{s.title}</h3>
              <p className="text-sm text-slate-600 mt-2">{s.desc}</p>
              <ul className="mt-4 space-y-2">
                {s.points.map((p) => (
                  <li key={p} className="flex items-center gap-2 text-sm text-slate-700">
                    <Target className="h-4 w-4 text-blue-600 shrink-0" /> {p}
                  </li>
                ))}
              </ul>
              <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-4">
                <div className="flex items-center gap-4 text-xs text-slate-500">
                  <span className="inline-flex items-center gap-1"><Timer className="h-3.5 w-3.5" /> 3h 30m</span>
                  <span className="inline-flex items-center gap-1"><Trophy className="h-3.5 w-3.5" /> Ranks</span>
                </div>
                <span className="inline-flex items-center text-sm font-semibold text-blue-700">
                  Start now <ChevronRight className="h-4 w-4" />
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
